module.exports = __webpack_public_path__ + "img/qr-placeholder.3f515564.png";